var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretDownFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caret-down-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.43514 8.355L1.83814 4.2435C1.41364 3.75975 1.75864 3 2.40289 3L9.59689 3C9.74107 2.99988 9.88223 3.04132 10.0035 3.11936C10.1247 3.1974 10.2209 3.30873 10.2805 3.44002C10.3401 3.57131 10.3606 3.717 10.3395 3.85963C10.3184 4.00227 10.2567 4.1358 10.1616 4.24425L6.56464 8.35425C6.49424 8.43481 6.40743 8.49937 6.31002 8.54361C6.21261 8.58785 6.10687 8.61073 5.99989 8.61073C5.8929 8.61073 5.78716 8.58785 5.68975 8.54361C5.59235 8.49937 5.50553 8.43481 5.43514 8.35425V8.355Z",
    fill: "#06163A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownFill);
export default __webpack_public_path__ + "static/media/caret-down-fill.d801ed0f964bf0e7ab483ff0d18206c0.svg";
export { ForwardRef as ReactComponent };